import { CxpStaffMember, CxpTask } from '../models';

export class SetCxpActiveRouteParams {
  static readonly type = '[Cxp] Set Active Route Params';
  constructor(
    public readonly requestId: number | null,
    public readonly deliverableId: number | null,
    /**
     * Item shown in the redesigned CRL side panel — the `:itemId` of the named
     * `panel` outlet child (PP-3753). `null` when the panel is closed. Optional
     * so existing dispatchers (e.g. deliverable nav) need no change.
     */
    public readonly itemId: number | null = null,
  ) {}
}

export class LoadCxpTasks {
  static readonly type = '[CxpTasks] Load';
  constructor(public readonly silent = false) {}
}

/**
 * Resets the loadable status to DEFAULT so `_loadTasksIfNeeded$` re-fires
 * a fresh fetch. Dispatched by the tasks container on construction so the
 * list reloads each time the user navigates back to it (deliverables that
 * just got marked VIEWED will then surface as completed).
 */
export class RefreshCxpTasks {
  static readonly type = '[CxpTasks] Refresh';
}

export class LoadCxpTasksSuccess {
  static readonly type = '[CxpTasks] Load Success';
  constructor(public readonly tasks: CxpTask[]) {}
}

export class LoadCxpTasksFailure {
  static readonly type = '[CxpTasks] Load Failure';
  constructor(public readonly error: unknown) {}
}

export class LoadCxpStaff {
  static readonly type = '[CxpTasks] Load Staff';
}

export class LoadCxpStaffSuccess {
  static readonly type = '[CxpTasks] Load Staff Success';
  constructor(public readonly staff: CxpStaffMember[]) {}
}

/**
 * Loads the cheap open-count from `GET /cxp/tasks/count` for the every-page
 * nav badge, independent of the full task list.
 */
export class LoadCxpTaskCount {
  static readonly type = '[CxpTasks] Load Count';
}

export class LoadCxpTaskCountSuccess {
  static readonly type = '[CxpTasks] Load Count Success';
  constructor(public readonly openCount: number) {}
}
